import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BookCallLink } from "@/components/BookCall";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

export const Wordmark = ({ className = "" }) => (
  <span className={`flex items-baseline ${className}`} data-testid="wordmark-logo">
    <span className="font-serif text-2xl leading-none text-white">Qu</span>
    <span className="font-sans text-xl font-semibold leading-none tracking-tight text-teal">Inflection</span>
  </span>
);

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="glass fixed inset-x-0 top-0 z-50 border-b border-white/10" data-testid="site-nav">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <Link to="/" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <Wordmark />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `group relative font-sans text-sm tracking-wide transition-colors duration-300 ${
                  isActive ? "text-teal" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
              <span
                className={`absolute -bottom-1 left-0 h-px bg-teal transition-[width] duration-300 ${
                  pathname === l.to ? "w-full" : "w-0 group-hover:w-full"
                }`}
              />
            </NavLink>
          ))}
          <BookCallLink testid="nav-book-call" className="btn-primary !px-6 !py-2.5">
            Book a Call
            <ArrowUpRight className="h-4 w-4" />
          </BookCallLink>
        </nav>

        <button
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="glass border-t border-white/10 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1 px-6 py-6">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 font-sans text-lg ${isActive ? "text-teal" : "text-white/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <BookCallLink
              onClick={() => setOpen(false)}
              testid="nav-mobile-book-call"
              className="btn-primary mt-4"
            >
              Book a Call
              <ArrowUpRight className="h-4 w-4" />
            </BookCallLink>
          </div>
        </div>
      )}
    </header>
  );
};
